export const getDataIndexMappedByField = <T>(data: T[], field: keyof T) =>
  data.reduce(
    (acc, item, index) => ({
      ...acc,
      [item[field] as unknown as string]: index,
    }),
    {}
  );
